<div class="version-dialog">
  <div class="dialog-header">
    <mat-icon class="header-icon">system_update</mat-icon>
    <h2 mat-dialog-title>Nueva versión disponible</h2>
  </div>

  <mat-dialog-content>
    <div class="version-comparison">
      <div class="version-badge current">
        <span class="version-label">Actual</span>
        <span class="version-number">v{{ data.currentVersion }}</span>
      </div>
      <mat-icon class="arrow-icon">arrow_forward</mat-icon>
      <div class="version-badge new">
        <span class="version-label">Nueva</span>
        <span class="version-number">v{{ data.newVersion }}</span>
      </div>
    </div>

    <div class="build-info">
      <mat-icon class="info-icon">calendar_today</mat-icon>
      <span>Fecha de build: {{ formattedDate }}</span>
    </div>

    <p class="update-message">
      La página se recargará automáticamente.
    </p>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button mat-stroked-button type="button" (click)="onCancel()" class="cancel-btn">
      Más tarde
    </button>
    <button mat-raised-button type="button" color="primary" (click)="onConfirm()">
      Actualizar ahora
    </button>
  </mat-dialog-actions>
</div>
